import useScreenSize from "../../context/ScreenContext";
import {
  AllCenteredColumn,
  MainText,
  SecondaryTitle,
} from "../../data/style/Style";

const NoDataDiv = (props) => {
  let { height, minHeight, header, text, icon } = props;
  const { mobileDevice } = useScreenSize();
  return (
    <AllCenteredColumn gap={1} minHeight={minHeight} height={height}>
      {icon}
      <SecondaryTitle sx={{ fontSize: !mobileDevice && "1rem !important" }}>
        {header}
      </SecondaryTitle>
      <MainText>{text}</MainText>
    </AllCenteredColumn>
  );
};

export default NoDataDiv;
